<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoProceso
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectPuntoVenta
                    :model="itemActivo.Id_PuntoVenta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarPuntoVenta"
                  />
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Prefijo*"
                    v-model="itemActivo.PrefijoPuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectModulo
                    :model="itemActivo.Id_Modulo"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarModulo"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectTipoComprobante
                    :id_Modulo="itemActivo.Id_Modulo"
                    :model="itemActivo.Id_TipoComprobante"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarTipoComprobante"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectTalonario
                    :id_PuntoVenta="itemActivo.Id_PuntoVenta"
                    :model="itemActivo.Id_Talonario"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarTalonario"
                  />
                </v-flex>
                <v-flex xs6 md2 offset-md2>
                  <v-text-field
                    label="Letra"
                    v-model="itemActivo.Letra"
                    v-mask="'A'"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Nº*"
                    v-model="itemActivo.Numero"
                    v-mask="'########'"
                    :rules="[rules.requerido]"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    label="Titular"
                    v-model="itemActivo.NombreTitular"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Fecha"
                    v-model="iFecha"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <Importe
                    label="Total"
                    :model="itemActivo.Total"
                    :readonly="true"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import { eventBus } from "@/main";
import EncabezadoProceso from "@/components/EncabezadoProceso";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import Importe from "@/components/Importe";
import SelectModulo from "@/components/Sistema/SelectModulo";
import SelectTipoComprobante from "@/components/Sistema/SelectTipoComprobante";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import SelectTalonario from "@/components/Sistema/SelectTalonario";
export default {
  name: "ComprobanteAnularPorTipoComprobante",
  components: {
    EncabezadoProceso,
    PieCrud,
    Mensaje,
    Importe,
    SelectModulo,
    SelectTipoComprobante,
    SelectPuntoVenta,
    SelectTalonario
  },
  data() {
    return {
      titulo: "Anula Comprobante",
      itemVacio: {
        Id_Modulo: 0,
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Id_PuntoVenta: 0,
        PrefijoPuntoVenta: 0,
        Id_Talonario: 0,
        Letra: "",
        Numero: "",
        Fecha: "",
        NombreTitular: "",
        Total: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  computed: {
    iFecha() {
      return this.itemActivo.Fecha
        ? moment(this.itemActivo.Fecha)
            .locale("es")
            .format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Ejecutar":
          if (this.$refs.form.validate()) this.buscar();
          break;
        case "AceptarConfirmacionBorrar":
          this.mostrarMensaje(false);
          this.anular();
          break;
        case "CancelarAviso":
        case "CancelarConfirmacionBorrar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      setTimeout(() => {
        eventBus.$emit("setearFocoSelectPuntoVenta");
      }, 100);
    },
    seleccionarModulo(item) {
      this.itemActivo.Id_Modulo = item.Id_Modulo;
      this.itemActivo.NombreModulo = item.Nombre;
    },
    seleccionarTipoComprobante(item) {
      this.itemActivo.Id_TipoComprobante = item.Id_TipoComprobante;
      this.itemActivo.NombreTipoComprobante = item.Nombre;
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.PrefijoPuntoVenta = item.Prefijo;
    },
    seleccionarTalonario(item) {
      this.itemActivo.Id_Talonario = item.Id_Talonario;
      this.itemActivo.Letra = item.Letra;
    },
    buscar() {
      switch (this.itemActivo.NombreModulo) {
        case this.$nombreModulo_Venta:
          this.buscarVenta();
          break;
        case this.$nombreModulo_Compra:
          this.buscarCompra();
          break;
        case this.$nombreModulo_Caja:
          this.buscarVale();
          break;
        case this.$nombreModulo_Gremio:
          this.buscarValeBeneficio();
          break;
      }
    },
    buscarVenta() {
      this.loading = true;
      HttpHelper.get("Venta/BuscarPorNumero", {
        id_Talonario: this.itemActivo.Id_Talonario,
        numero: this.itemActivo.Numero
      })
        .then(response => {
          if (response.data.length == 0) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "No Existe",
              "No se encontró un comprobante con los filtros ingresados. Verifique e intente nuevamente."
            );
          } else {
            if (response.data.length > 1) {
              this.mostrarMensaje(
                true,
                "Aviso",
                "Numeración Duplicada",
                "Se encontró más de un comprobante con los filtros ingresados. Se procede a mostrar solamente el primero."
              );
            }
            this.itemActivo.Id_Comprobante = response.data[0].Id_Venta;
            this.itemActivo.Fecha = response.data[0].Fecha;
            this.itemActivo.NombreTitular = response.data[0].NombreTitular;
            this.itemActivo.Total = response.data[0].Total;
            this.loading = false;
            if (this.itemActivo.NombreTipoComprobante == "FACTURA")
              this.mostrarMensaje(
                true,
                "Aviso",
                "Anulación No Permitida",
                "Recuerde que para anular Facturas deberá generar la Nota de Crédito correspondiente (AFIP RG 3561/13)."
              );
            else this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarCompra() {
      this.loading = true;
      HttpHelper.get("Compra/BuscarPorNumero", {
        id_Talonario: this.itemActivo.Id_Talonario,
        numero: this.itemActivo.Numero
      })
        .then(response => {
          this.loading = false;
          if (response.data.length == 0) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "No Existe",
              "No se encontró un comprobante con los filtros ingresados. Verifique e intente nuevamente."
            );
          } else {
            if (response.data.length > 1) {
              this.mostrarMensaje(
                true,
                "Aviso",
                "Numeración Duplicada",
                "Se encontró más de un comprobante con los filtros ingresados. Se procede a mostrar solamente el primero."
              );
            }
            this.itemActivo.Id_Comprobante = response.data[0].Id_Compra;
            this.itemActivo.Fecha = response.data[0].Fecha;
            this.itemActivo.NombreTitular = response.data[0].NombreTitular;
            this.itemActivo.Total = response.data[0].Total;
            this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVale() {
      this.loading = true;
      HttpHelper.get("Vale/BuscarPorNumero", {
        id_Talonario: this.itemActivo.Id_Talonario,
        numero: this.itemActivo.Numero
      })
        .then(response => {
          this.loading = false;
          if (response.data.length == 0) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "No Existe",
              "No se encontró un comprobante con los filtros ingresados. Verifique e intente nuevamente."
            );
          } else {
            if (response.data.length > 1) {
              this.mostrarMensaje(
                true,
                "Aviso",
                "Numeración Duplicada",
                "Se encontró más de un comprobante con los filtros ingresados. Se procede a mostrar solamente el primero."
              );
            }
            this.itemActivo.Id_Comprobante = response.data[0].Id_Vale;
            this.itemActivo.Fecha = response.data[0].Fecha;
            this.itemActivo.NombreTitular = response.data[0].NombreTitular;
            this.itemActivo.Total = response.data[0].Total;
            this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarValeBeneficio() {
      this.loading = true;
      HttpHelper.get("ValeBeneficio/BuscarPorNumero", {
        id_Talonario: this.itemActivo.Id_Talonario,
        numero: this.itemActivo.Numero
      })
        .then(response => {
          this.loading = false;
          if (response.data.length == 0) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "No Existe",
              "No se encontró un comprobante con los filtros ingresados. Verifique e intente nuevamente."
            );
          } else {
            if (response.data.length > 1) {
              this.mostrarMensaje(
                true,
                "Aviso",
                "Numeración Duplicada",
                "Se encontró más de un comprobante con los filtros ingresados. Se procede a mostrar solamente el primero."
              );
            }
            this.itemActivo.Id_Comprobante = response.data[0].Id_ValeBeneficio;
            this.itemActivo.Fecha = response.data[0].Fecha;
            this.itemActivo.NombreTitular = response.data[0].NombreTitular;
            this.itemActivo.Total = response.data[0].Total;
            this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    anular() {
      switch (this.itemActivo.NombreModulo) {
        case this.$nombreModulo_Venta:
          this.anularVenta();
          break;
        case this.$nombreModulo_Compra:
          this.anularCompra();
          break;
        case this.$nombreModulo_Caja:
          this.anularVale();
          break;
        case this.$nombreModulo_Gremio:
          this.anularValeBeneficio();
          break;
      }
    },
    anularVenta() {
      this.loading = true;
      HttpHelper.get("Venta/Anular", {
        id_Venta: this.itemActivo.Id_Comprobante
      })
        .then(response => {
          this.loading = false;
          if (response.data == "OK") {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Listo",
              "El comprobante fué anulado con éxito."
            );
          } else {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Anulación No Realizada",
              "El comprobante no pudo ser anulado. Verifique e intente nuevamente."
            );
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    anularCompra() {
      this.loading = true;
      HttpHelper.get("Compra/Anular", {
        id_Compra: this.itemActivo.Id_Comprobante
      })
        .then(response => {
          this.loading = false;
          if (response.data == "OK") {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Listo",
              "El comprobante fué anulado con éxito."
            );
          } else {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Anulación No Realizada",
              "El comprobante no pudo ser anulado. Verifique e intente nuevamente."
            );
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    anularVale() {
      this.loading = true;
      HttpHelper.get("Vale/Anular", {
        id_Vale: this.itemActivo.Id_Comprobante
      })
        .then(response => {
          this.loading = false;
          if (response.data == "OK") {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Listo",
              "El comprobante fué anulado con éxito."
            );
          } else {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Anulación No Realizada",
              "El comprobante no pudo ser anulado. Verifique e intente nuevamente."
            );
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    anularValeBeneficio() {
      this.loading = true;
      HttpHelper.get("ValeBeneficio/Anular", {
        id_ValeBeneficio: this.itemActivo.Id_Comprobante
      })
        .then(response => {
          this.loading = false;
          if (response.data == "OK") {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Listo",
              "El comprobante fué anulado con éxito."
            );
          } else {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Anulación No Realizada",
              "El comprobante no pudo ser anulado. Verifique e intente nuevamente."
            );
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
